import React from 'react'
import { useSelector } from 'react-redux'
import {
  Box,
  Typography
} from '@mui/material'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { getCartQuantitySelector } from '@/modules/cart/cartSlice'
import CartDialog from '@/modules/cart/components/CartDialog'
import { useEvent } from '@/modules/event/eventSlice'

export const CartIcon = () => {
  const event = useEvent()
  const cartQuantity = useSelector(getCartQuantitySelector)
  const hasProducts = event?.products?.length > 0
  
  if (!hasProducts) {
    return null
  }
  
  return (
    <CartDialog
      renderButton={(cb) => (
        // @ts-ignore
        <Box 
          data-cy={'cart_icon_button'}
          sx={{ position: 'relative', cursor: 'pointer', left: '-15px' }} 
          onClick={cb}>
          {cartQuantity > 0 &&
            <Box
              display={'flex'}
              justifyContent={'center'}
              alignContent={'center'}
              alignItems={'center'}
              sx={{
                position: 'absolute',
                top: '-12px',
                right: '-12px',
                fontSize: '10px',
                backgroundColor: 'primary.main',
                color: 'white',
                width: '22px',
                height: '22px',
                borderRadius: '20px'
              }}>
              <Typography variant={'button'}>{cartQuantity}</Typography>

            </Box>
          }
          <ShoppingCartIcon color={'action'}/>
        </Box>
      )}
     />
  )
}